import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Dialog } from '@material-ui/core';

import IconDialog from '../../../../../../commons/dialogV2/IconDialog';
import { formatOrdinalPlanDate } from '../../planScheduleNotice';
import { useStyles } from './cancelConnectPlanDialog.styles';
import useCancelConnectPlanDialogState from './useCancelConnectPlanDialogState';
import ConfirmStep from './steps/ConfirmStep';
import ProcessingStep from './steps/ProcessingStep';

const TITLE_ID = 'cancel-connect-plan-dialog-title';

function CancelConnectPlanDialog ({ open, onClose, onConfirm, planName, pricePerMonth, nextRenewalDate }) {
    const classes = useStyles();
    const { checked, setChecked, step, error, handleConfirm } =
        useCancelConnectPlanDialogState({ onConfirm });

    return (
        <React.Fragment>
            <Dialog
                open={open && step !== 'done'}
                onClose={() => {
                    if (step !== 'processing') {
                        onClose();
                    }
                }}
                maxWidth={false}
                aria-labelledby={TITLE_ID}
                PaperProps={{ className: classes.paper }}
                BackdropProps={{
                    style: {
                        backgroundColor: 'rgba(10,14,40,0.45)',
                        backdropFilter: 'blur(3px)',
                    },
                }}
            >
                {step === 'confirm' && (
                    <ConfirmStep
                        titleId={TITLE_ID}
                        onClose={onClose}
                        planName={planName}
                        pricePerMonth={pricePerMonth}
                        checked={checked}
                        setChecked={setChecked}
                        error={error}
                        handleConfirm={handleConfirm}
                    />
                )}

                {step === 'processing' && <ProcessingStep />}
            </Dialog>

            <IconDialog
                open={open && step === 'done'}
                title="Subscription cancelled"
                message={nextRenewalDate
                    ? `Your Connect subscription will be cancelled on ${formatOrdinalPlanDate(nextRenewalDate)}`
                    : 'Your Connect subscription has been cancelled.'}
                confirmLabel="Close"
                showPrimaryButton
                showSecondaryButton={false}
                onConfirm={onClose}
                onClose={onClose}
            />
        </React.Fragment>
    );
}

CancelConnectPlanDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    planName: PropTypes.string.isRequired,
    pricePerMonth: PropTypes.number.isRequired,
    nextRenewalDate: PropTypes.string,
};

CancelConnectPlanDialog.defaultProps = {
    nextRenewalDate: null,
};

const ObservedCancelConnectPlanDialog = observer(CancelConnectPlanDialog);
export default ObservedCancelConnectPlanDialog;
